import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import './Accueil.css';

import Hero from '../Hero/Hero';

import fxImage from '../../assets/fx.png';
import drrrrImage from '../../assets/drrrr.png';
import fzzzImage from '../../assets/fzzz.png';
import zrrImage from '../../assets/zrr.png';
import ahmedImage from '../../assets/ahmed.png';
import ahmeddImage from '../../assets/ahmedd.png';

import Footer from '../Footer/Footer';

const Accueil = ({ renderHero = true, contactDev = true}) => {
  const images = [
    drrrrImage,
    fxImage,
    zrrImage,
    ahmeddImage,
    ahmedImage,
    fzzzImage,
  ];

  // =========================================================
  // MODIFICATION CLÉ: Gestion du Scroll Vertical (via Class CSS)
  // =========================================================
  useEffect(() => {
    // 1. Ajout de la classe CSS qui supprime le scroll au body
    document.body.classList.add('accueil-no-scroll');

    // 2. Retrait de la classe lors du démontage pour réactiver le scroll ailleurs
    return () => {
      document.body.classList.remove('accueil-no-scroll');
    };
  }, []); 
  // =========================================================

  return (
    <div>
      {renderHero && <Hero />}
      <Carousel slides={images} />

      {contactDev && <Footer />}

    </div>
  );
};

export default Accueil;

// --------------------
// CAROUSEL COMPONENT
// --------------------
const Carousel = ({ autoSlide = true, autoSlideInterval = 3000, slides }) => {
  const [curr, setCurr] = useState(0);

  const next = () => setCurr((curr) => (curr === slides.length - 1 ? 0 : curr + 1));

  useEffect(() => {
    if (autoSlide) {
      const slideInterval = setInterval(next, autoSlideInterval);
      return () => clearInterval(slideInterval);
    }
  }, [autoSlide, autoSlideInterval]);

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === curr ? 'active' : ''}`}
          >
            <img src={slide} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* BUTTON centered */}
      <div className="carousel-button">
        <Link to="/RejoignezNous" className="join-button">
          Rejoignez Nous
        </Link>
      </div>

      {/* DOTS navigation */}
      <div className="carousel-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === curr ? 'active-dot' : ''}`}
            onClick={() => setCurr(index)}
          ></button>
        ))}
      </div>

    </div>
  );
};